'use strict';

const $ = require('jquery');
const offcanvasdialog = require('../components/offcanvasdialog');

let initialized = false;

/**
 * Initializes fit guide fly-ins.
 *
 * @returns {void}
 */
function initializeFlyin() {
    offcanvasdialog.init(
        'flyin-link-stamp-rally',
        {
            overlay: true,
            additionalClass: 'stamp-rally-flyin',
            closeIconClass: 'icon-close-thin',
            reloadContentAlways: true
        },
        function ($triggerButton, $flyinContainer) {
            const $flyinContent = $flyinContainer.find('.ocd-content');
            const $flyinCloseButton = $flyinContainer.find('.ocd-close');

            // Move close button so that it is a sibling of the main content container.
            // That way the button isn't lost when the fly-in's content is reloaded.
            $flyinCloseButton.detach().appendTo($flyinContainer);
            // The fly-in starts with only one page loaded - make it's content visible.
            $flyinContent.children().first().addClass('active');

            // Additional sub-pages are loaded by making a single AJAX call per sub-page
            // and are then opened/closed by adding/removing the .active class.
            // This is done to reduce network traffic and maintain the sub-page state.

            clickEvents();

            $('.info-overlay a').click(function (e) {
                e.preventDefault();

                const pageClass = $(this).attr('class');
                const pageAlreadyLoaded = $flyinContent.children().is('.' + pageClass);

                if (pageAlreadyLoaded) {
                    $flyinContent
                        .children()
                        .filter('.' + pageClass)
                        .addClass('active');
                    $flyinContent.children().first().removeClass('active');
                } else {
                    $.ajax({
                        url: $(this).attr('href'),
                        type: 'GET',
                        dataType: 'html',

                        success: function (response) {
                            // Hide all fly-in pages.
                            $flyinContent.children().removeClass('active');

                            // Add the new sub-page, give it a unique class and make it visible.
                            $flyinContent.append(response);
                            $flyinContent
                                .children()
                                .last()
                                .addClass(pageClass + ' active');

                            $flyinContent
                                .children()
                                .last()
                                .find('.flyin-content')
                                .prepend(
                                    '<button class="button button-trans back-button">' +
                                        '<i class="icon icon-arrow_previous"><!-- icon --></i>' +
                                        '<span> 戻る </span>' +
                                        '</button>'
                                );

                            $flyinContent
                                .children()
                                .last()
                                .find('.back-button')
                                .click(function () {
                                    $flyinContent.children().removeClass('active');
                                    $flyinContent.children().first().addClass('active');
                                });
                        }
                    });
                }
            });
        }
    );
}

const clickEvents = () => {
    const url = $('.my-stamp-collected').data('url');
    $('.my-stamp-collected-item-active .button-draw').each(function (i, item) {
        $(item).on('click', function () {
            const campId = $(this).data('camp-id');
            const $drawbtn = $(this);
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    isDraw: true,
                    campId: campId
                }
            }).done(function (res) {
                if (res.success) {
                    var $msg = $drawbtn.closest('.draw').data('msg');
                    $('.small-draw-success-msg').removeClass('hidden');
                    $drawbtn
                        .closest('.draw')
                        .empty()
                        .html('<div class="participate-in-draw"> <i class="icon icon-check"></i>' + $msg + '</div>');

                    $('.flyin-content, .scrolling-content').animate({
                        scrollTop: 0
                    });
                }
            });
        });
    });

    $('.main-draw-btn').on('click', function () {
        const $maindrawbtn = $(this);
        $.ajax({
            url: url,
            type: 'POST',
            data: {
                isDraw: false
            }
        }).done(function (res) {
            if (res.success) {
                $('.main-draw-success-msg').removeClass('hidden');
                $maindrawbtn.closest('.main-draw-enabled').remove();
            }
        });
        $('.flyin-content, .scrolling-content').animate({
            scrollTop: 0
        });
    });
};

const init = () => {
    initialized = true;
    initializeFlyin();
    clickEvents();
};

module.exports = {
    init,
    isInitialized: () => initialized
};
